interface UserAvatarProps {
  firstname: string
  lastname: string
  size?: number
  className?: string
}

const GRADIENT_PAIRS: Array<[string, string]> = [
  ['#6366f1', '#8b5cf6'], // indigo → violet
  ['#3b82f6', '#06b6d4'], // blue → cyan
  ['#10b981', '#14b8a6'], // emerald → teal
  ['#f59e0b', '#f97316'], // amber → orange
  ['#ef4444', '#f43f5e'], // red → rose
  ['#8b5cf6', '#d946ef'], // violet → fuchsia
  ['#0ea5e9', '#6366f1'], // sky → indigo
  ['#14b8a6', '#22c55e'], // teal → green
]

function getGradientIndex(name: string): number {
  let hash = 0
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash)
  }
  return Math.abs(hash) % GRADIENT_PAIRS.length
}

export function UserAvatar({ firstname, lastname, size = 28, className }: UserAvatarProps) {
  const initials = `${firstname.charAt(0)}${lastname.charAt(0)}`.toUpperCase()
  const fullName = `${firstname}${lastname}`
  const [color1, color2] = GRADIENT_PAIRS[getGradientIndex(fullName)]!
  const gradientId = `avatar-grad-${fullName.replace(/\s/g, '')}`

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      className={className}
      style={{ display: 'block', borderRadius: '50%', width: size, height: size, minWidth: size, minHeight: size }}
      role="img"
      aria-label={`${firstname} ${lastname}`}
    >
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={color1} />
          <stop offset="100%" stopColor={color2} />
        </linearGradient>
      </defs>
      <circle cx="50" cy="50" r="50" fill={`url(#${gradientId})`} />
      <text
        x="50"
        y="52"
        textAnchor="middle"
        dominantBaseline="central"
        fill="white"
        fontSize="42"
        fontWeight="600"
        fontFamily="system-ui, sans-serif"
      >
        {initials}
      </text>
    </svg>
  )
}
